export type UserCustomData = Record<string, any> | undefined | null;

export interface FailedDepositsReportConfig {
	enabled?: boolean;
	baseUrl?: string;
	loginPath?: string;
	reportPath?: string;
	failedDepositsPath?: string;
	token?: string;
	accessToken?: string;
	bearerToken?: string;
	apiToken?: string;
	username?: string;
	password?: string;
}

export interface NormalizedFailedDepositsReportConfig {
	baseUrl: string;
	loginPath: string;
	reportPath: string;
	token?: string;
	username?: string;
	password?: string;
}

export const getObject = (value: unknown): Record<string, any> | undefined =>
	value && typeof value === 'object' && !Array.isArray(value)
		? (value as Record<string, any>)
		: undefined;

export const getFailedDepositsReportConfig = (
	customData: UserCustomData,
): FailedDepositsReportConfig | undefined => {
	const data = getObject(customData);
	if (!data) {
		return undefined;
	}

	const config = getObject(
		data.failedDepositsReport ||
			data.failedDeposits ||
			data.failedDeposit,
	);

	return config as FailedDepositsReportConfig | undefined;
};

export const normalizeFailedDepositsReportConfig = (
	config: FailedDepositsReportConfig | undefined,
): NormalizedFailedDepositsReportConfig | undefined => {
	if (!config || config.enabled === false) {
		return undefined;
	}

	const baseUrl = config.baseUrl?.trim().replace(/\/+$/, '');
	const token = (
		config.token ||
		config.accessToken ||
		config.bearerToken ||
		config.apiToken
	)?.trim();
	const username = config.username?.trim();
	const password = config.password;

	if (!baseUrl || (!token && (!username || !password))) {
		return undefined;
	}

	return {
		baseUrl,
		loginPath: config.loginPath?.trim() || '/api/v1/login',
		reportPath:
			config.reportPath?.trim() ||
			config.failedDepositsPath?.trim() ||
			'/api/v1/failed-deposits',
		token,
		username: token ? undefined : username,
		password: token ? undefined : password,
	};
};

export const hasFailedDepositsReportAccess = (customData: UserCustomData) =>
	Boolean(
		normalizeFailedDepositsReportConfig(
			getFailedDepositsReportConfig(customData),
		),
	);
